import React from "react";
import styled from "styled-components";

const DimVoiceToggle = ({ active, onClick }) => {
  return (
    <ToggleContainer>
      <ToggleButton active={active} onClick={onClick}>
        <ToggleTrack active={active}>
          <ToggleThumb active={active} />
        </ToggleTrack>
      </ToggleButton>
    </ToggleContainer>
  );
};

export default DimVoiceToggle;

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
`;

const ToggleTrack = styled.div`
  width: 50px;
  height: 25px;
  border-radius: 16px;
  background: ${({ active, theme }) => active ? 'rgba(45, 49, 72, 1)' : theme.sidebar.borderColor};
  position: relative;
  transition: all 0.3s ease;
`;

const ToggleThumb = styled.div`
  width: 26.47px;
  height: 21.77px;
  border-radius: 20px;
  background: ${({ active, theme }) => active ? 'rgba(146, 139, 237, 1)' : theme.menu.background};
  position: absolute;
  top: 1.61px;
  left: ${({ active }) => active ? '21px' : '3px'};
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;